import { graphql } from 'gql'

export const DEACTIVATE_ALL_DOMAINS_PRODUCT = graphql(`
  mutation deactivateAllDomainsProduct($input: DeactivateAllDomainsProductInput!) {
    deactivateAllDomainsProduct(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`)
